import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { CheckoutSegmentProps } from '../../../types';
import { useTheme } from '../../../../theme';
import { planeIcon } from '../../../../BoardingPassDesk/Icons';
import { format } from '../../../../utils';

const SegmentCompact: React.FC<CheckoutSegmentProps> = ({ segment }) => {
	const { SegmentCompact: css } = useTheme('RetrieveBooking');
	const { t } = useTranslation('Segment');

	const fareFamily = segment.fareFamily;
	const firstSegment = segment.segments[0];
	const lastSegment = segment.segments[segment.segments.length - 1];

	return (
		<div className={css.wrapper}>
			<div className={css.header}>
				<div className={css.segmentInfo}>
					<div className={css.planeIcon}>{planeIcon}</div>

					<div>
						<span className={css.segmentInfo__item}>
							{firstSegment.departure.airport.city.name} – {lastSegment.arrival.airport.city.name}
						</span>

						<span className={css.segmentInfo__item}>
							{format(firstSegment.departure.date, 'dd MMM, yyyy')}
						</span>

						<span className={css.segmentInfo__item}>
							{firstSegment.departure.time.substr(0, 5)} - {lastSegment.arrival.time.substr(0, 5)}{' '}
						</span>
					</div>
				</div>

				<div className={css.fareFamily}>
					{fareFamily?.airline?.icon && (
						<div
							className={css.fareFamily__img}
							style={{
								backgroundImage: `url(${fareFamily.airline.icon})`
							}}
						/>
					)}

					<span>
						{fareFamily?.airline?.name && `${fareFamily.airline.name}, `}
						{fareFamily?.title?.toLowerCase()}
					</span>
				</div>
			</div>

			<div className={css.footer}>
				<div className={css.flightInfo}>
					<span className={css.flightInfo__item}>
						{firstSegment.operatingAirline.iata} {firstSegment.flightNumber}
					</span>

					{firstSegment.departure.terminal && (
						<span className={css.flightInfo__item}>
							{t('Terminal')}: {firstSegment.departure.terminal}
						</span>
					)}
				</div>
			</div>
		</div>
	);
};

export default SegmentCompact;
